import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import clsx from "clsx";
const useStyles = makeStyles({
  cardHeading: {
    color: (props) => (props.color === "alternate" ? "white" : "black"),
    marginBottom: "0 !important",
    // fontSize: "0.9em !important",
    // fontWeight: '700',
  },
  readmoreBtn: {
    color: (props) =>
      props.color === "alternate" ? "white !important" : "black !important",
    textTransform: "capitalize !important",
    fontWeight: "400 !important",
    backgroundColor: (props) =>
      props.buttonBG ? `${props.buttonBG} !important` : "inherit",
    "&:hover": {
      textDecoration: (props) =>
        props.style !== "button" ? "underline !important" : "inherit",
    },
    borderRadius: "10px !important",
    padding: "10px 24px !important",
    marginTop: "6px !important",
    // padding: (props) =>
    //   props.style === "button" ? "5px !important" : "inherit",
    float: (props) => (props.float ? props.float : "inherit"),
  },
  cardInner: {
    backgroundColor: (props) =>
      props.innerCardBG ? `${props.innerCardBG} !important` : null,

    boxShadow: (props) =>
      props.innerCardNoShadow ? "none !important" : "inherit",
  },
  cardInnerNoPadding: {
    "&>div": {
      padding: (props) =>
        props.innerCardContentNoPadding ? "5px 0 0 0 !important" : "inherit",
    },
  },
  cardInnerHorizontalPadding: {
    "&>div:not(.MuiCardActions-root)": {
      paddingLeft: (props) =>
        props.innerCardHorizontalPadding
          ? `${props.innerCardHorizontalPadding} !important`
          : "inherit",
      paddingRight: (props) =>
        props.innerCardHorizontalPadding
          ? props.innerCardHorizontalPaddingRight
            ? `${props.innerCardHorizontalPaddingRight} !important`
            : `${props.innerCardHorizontalPadding} !important`
          : "inherit",
    },
  },
  cardOuter: {
    padding: 10,
    "& >div ": {
      padding: 0,
      paddingBottom: "0 !important",
    },
  },
  outerCardNoPaddingTop: {
    paddingTop: "0 !important",
  },
  cardAction: {
    float: (props) => `${props.showMoreButtonPlacement} !important`,
    paddingLeft: "0px !important",
    paddingTop: "10px !important",
    // marginLeft: "10px",
    marginBottom: "10px",
  },
});

export function CardHeading(props) {
  const classes = useStyles(props);
  const { text } = props;
  return (
    <Typography
      className={classes.cardHeading}
      fontWeight="700"
      variant="body2"
    >
      {text}
    </Typography>
  );
}

export function ViewMoreButton(props) {
  var { onClickCB, text, style, displayIcon } = props;
  if (!text) text = "View";
  const classes = useStyles(props);
  return (
    <Button
      endIcon={displayIcon && <ArrowForward />}
      className={classes.readmoreBtn}
      onClick={onClickCB}
      //   style={{ style }}
    >
      <Typography variant="caption">{text}</Typography>
    </Button>
  );
}

export function DashboardCard(props) {
  var {
    showMoreButton,
    moreButtonColor,
    moreButtonText,
    showMoreButtonStyle,
    buttonBG,
    showMoreButtonHasIcon,
    showMoreButtonPlacement,
    innerCardContentNoPadding,
    innerCardHorizontalPadding,
    outerCardNoPaddingTop,
    onViewMoreClick,
  } = props;
  const classes = useStyles(props);
  if (showMoreButtonHasIcon === undefined) showMoreButtonHasIcon = true;
  if (showMoreButtonPlacement === undefined) showMoreButtonPlacement = "left";

  return (
    <Grid item xs={12}>
      <Card
        className={clsx(classes.cardOuter, {
          [classes.outerCardNoPaddingTop]: outerCardNoPaddingTop,
        })}
      >
        <CardContent>
          <Card
            className={clsx(classes.cardInner, {
              [classes.cardInnerNoPadding]: innerCardContentNoPadding,
              [classes.cardInnerHorizontalPadding]: innerCardHorizontalPadding,
            })}
          >
            <CardContent>{props.children}</CardContent>
            {showMoreButton && (
              <CardActions className={classes.cardAction}>
                <ViewMoreButton
                  color={moreButtonColor}
                  text={moreButtonText}
                  style={showMoreButtonStyle}
                  buttonBG={buttonBG}
                  displayIcon={showMoreButtonHasIcon}
                  onClickCB={onViewMoreClick}
                />
              </CardActions>
            )}
          </Card>
        </CardContent>
      </Card>
    </Grid>
  );
}
